import { Row } from '@tanstack/react-table';
import useAppUser from 'hooks/useAppUser';
import useFormatCurrency from 'hooks/useFormatCurrency';
import { Currency } from 'models/Currency';
import { FeeAmountTypeEnum, PropertyInternalFee } from 'models/PropertyFees';

const AmountCell = ({
  row,
  getValue,
  currency,
}: {
  row: Row<PropertyInternalFee>;
  getValue: () => number;
  currency?: Currency;
}) => {
  const {
    // @ts-expect-error TS2339 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    agency: { currency: agencyCurrency },
  } = useAppUser();
  const formatCurrency = useFormatCurrency();
  const value = getValue();

  return row.original.amountType === FeeAmountTypeEnum.TAX
    ? `${value}%`
    : formatCurrency({ currency: currency || agencyCurrency, value });
};

export default AmountCell;
